module.exports = __webpack_public_path__ + "static/img/solution_img_4.e6713db.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/nav/img/nav-solution/solution-n/solution_img_4.png
// module id = STvv
// module chunks = 22